import { createAsyncThunk } from "@reduxjs/toolkit";
import NotificationService from "../services/Notification.service";
import {
    GET_NOTIFICATION, UPDATE_NOTIFICATION_STATUS,
} from "./Notification.type";

export const getNotification = createAsyncThunk(
    GET_NOTIFICATION,
    async (isSeen:boolean) =>{
        const response = await NotificationService.getNotification(isSeen);
        return response.data;
    }
)
export const updateNotificationStatus = createAsyncThunk(
    UPDATE_NOTIFICATION_STATUS,
    async (id:string) =>{
        const response = await NotificationService.updateNotificationStatus(id);
        return response.data;
    }
)

